"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAuthorization = exports.getClients = exports.networkWrapper = void 0;
var discount_1 = require("../api/discount");
var auth_1 = require("../api/auth");
var customer_1 = require("../api/customer");
var company_1 = require("../api/company");
var logicalday_1 = require("../api/logicalday");
var resource_1 = require("../api/resource");
var activity_1 = require("../api/activity");
var booking_1 = require("../api/booking");
var sale_1 = require("../api/sale");
var catalog_1 = require("../api/catalog");
var notifications_1 = require("../api/notifications");
var appConfig_1 = require("../api/appConfig");
var graphql_1 = require("../utils/graphql");
var rest_1 = require("../utils/rest");
var elastic_1 = require("../utils/elastic");
var localstorage_1 = require("./localstorage");
exports.networkWrapper = {};
var getClients = function () {
    if (!exports.networkWrapper.restClient ||
        !exports.networkWrapper.graphqlClient ||
        !exports.networkWrapper.elasticClient) {
        throw new Error('NetworkWrapper with restClient or graphqlClient not initialized');
    }
    return exports.networkWrapper;
};
exports.getClients = getClients;
var clients = function () { return ({
    discount: discount_1.init(),
    auth: auth_1.init(),
    customer: customer_1.init(),
    company: company_1.init(),
    logicalDay: logicalday_1.init(),
    resource: resource_1.init(),
    activity: activity_1.init(),
    booking: booking_1.init(),
    sale: sale_1.init(),
    catalog: catalog_1.init(),
    notifications: notifications_1.init(),
    appConfig: appConfig_1.init(),
}); };
var init = function (options) {
    localstorage_1.setUrls(options);
    var rest = rest_1.restClient(options === null || options === void 0 ? void 0 : options.saasApiUrl);
    var gql = graphql_1.gqlClient(options === null || options === void 0 ? void 0 : options.mkpApiUrl);
    var elastic = elastic_1.elasticClient(options === null || options === void 0 ? void 0 : options.mkpEsUrl);
    exports.networkWrapper.graphqlClient = gql;
    exports.networkWrapper.restClient = rest;
    exports.networkWrapper.elasticClient = elastic;
    rest.interceptors.response.use(function (response) { return response; }, function (error) {
        var _a;
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            localstorage_1.clearTokens();
            if (window && typeof window !== undefined) {
                window.location.replace((options === null || options === void 0 ? void 0 : options.loginUrl) || '/login');
            }
        }
        return Promise.reject(error);
    });
    return clients();
};
var updateAuthorization = function (saas, mkp) {
    rest_1.updateHeaders(exports.networkWrapper.restClient, {
        Authorization: saas,
    });
    graphql_1.updateHeaders(exports.networkWrapper.graphqlClient, {
        Authorization: mkp,
    });
    return true;
};
exports.updateAuthorization = updateAuthorization;
var wrapper = {
    init: init,
    clients: clients,
};
exports.default = wrapper;
